import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { map } from 'rxjs/operators';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoBudgetFilter } from 'app/shared/models/quote/budget-filter.model';
import { IDtoNote } from 'app/shared/models/quote/note.model';
import { IDtoBudgetNote } from 'app/shared/models/quote/budget-note.model';
import { IDtoBudgetList } from 'app/shared/models/quote/dto-budget-list.model';

@Injectable()
export class BudgetService {
    private quoteUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.quoteUrl = this.configurationService.serverSettings.quoteUrl;
            });
        }
    }
    public getCatalogPlanTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PlanTypes/getCatalogPlanTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogBudgetTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/BudgetTypes/getCatalogBudgetTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogExpenseTypes(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ExpenseTypes/getCatalogExpenseTypes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogInvoiceConcepts(): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/InvoiceConcepts/getCatalogInvoiceConcepts`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectCustomersByCustomerId(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectCustomersByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectCustomersByCustomerIdActive(customerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectCustomersByCustomerIdActive?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectsByCustomerIdAndEjecutive(customerId: number, userId: string): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectsByCustomerIdAndEjecutive?customerId=${customerId}&userId=${userId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectsByCustomerIdAndApprover(customerId: number, userId: string): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectsByCustomerIdAndApprover?customerId=${customerId}&userId=${userId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPlanTrademarksByProjectCustomerId(projectCustomerId: number): Observable<IDtoCatalog[]> {
        const url = `${this.quoteUrl}api/PlanTrademarks/getCatalogPlanTrademarksByProjectCustomerId?projectCustomerId=${projectCustomerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addBudget(dto: IDtoBudget): Observable<IResult> {
        const url =`${this.quoteUrl}api/Budgets/addBudget`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateBudget(dto: IDtoBudget): Observable<IResult> {
        const url =`${this.quoteUrl}api/Budgets/updateBudget`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getBudgetPositionDistribution(budgetId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudgetPositionDistribution?budgetId=${budgetId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBudgetSalaryDistribution(budgetId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudgetSalaryDistribution?budgetId=${budgetId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBudgetsByCustomerId(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudgetsByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBudget(budgetId: string): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudget?budgetId=${budgetId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public changeStatusBudget(dto: IDtoBudget): Observable<IResult> {
        const url =`${this.quoteUrl}api/Budgets/changeStatusBudget`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getBudgetsByFilter(dto: IDtoBudgetFilter): Observable<IResult> {
        const url =`${this.quoteUrl}api/Budgets/getBudgetsByFilter`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public duplicateBudget(dto: IDtoBudgetList): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/duplicateBudget`;
        return this.service.post(url, dto)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteBudget(budgetId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/deleteBudget?budgetId=${budgetId}`;
        return this.service.delete(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addNote(dto: IDtoNote): Observable<IResult> {
        const url =`${this.quoteUrl}api/Notes/addNote`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getNotes(): Observable<IResult> {
        const url = `${this.quoteUrl}api/Notes/getNotes`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteNote(noteId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Notes/deleteNote?noteId=${noteId}`;
        return this.service.delete(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addBudgetNote(dto: IDtoBudgetNote): Observable<IResult> {
        const url =`${this.quoteUrl}api/BudgetNotes/addBudgetNote`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getBudgetNotes(budgetId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/BudgetNotes/getBudgetNotes?budgetId=${budgetId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteBudgetNote(budgetNoteId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/BudgetNotes/deleteBudgetNote?budgetNoteId=${budgetNoteId}`;
        return this.service.delete(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBudgetVersions(budgetId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudgetVersions?budgetId=${budgetId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public approveBudget(dto: IDtoCatalog): Observable<IResult> {
        const url =`${this.quoteUrl}api/Budgets/approveBudget`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getBudgetWithBonusByCustomerId(customerId: number): Observable<IResult> {
        const url = `${this.quoteUrl}api/Budgets/getBudgetWithBonusByCustomerId?customerId=${customerId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogProjectCustomersByCustomerIdActivePayrollRequest(customerId: number): Observable<IDtoCatalog[]> {
      const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectCustomersByCustomerIdActivePayrollRequest?customerId=${customerId}`;
      return this.service.get(url)
          .pipe(
              map((res: any) => {
                  return res;
              })
          );
  }
  public getCatalogProjectCustomersByCustomerIdActivePayroll(customerId: number): Observable<IDtoCatalog[]> {
    const url = `${this.quoteUrl}api/ProjectCustomers/getCatalogProjectCustomersByCustomerIdActivePayroll?customerId=${customerId}`;
    return this.service.get(url)
        .pipe(
            map((res: any) => {
                return res;
            })
        );
}
}
